export default __webpack_public_path__ + "static/media/footer-black.ff8b532a.jpg";